import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    meta: { title: '玉山县人民医院SPD' },
    component: () => import('@/views/IndexView')
  },
  {
    path: '/mine',
    name: 'mine',
    meta: { title: '个人中心' },
    component: () => import('@/views/MineView')
  },
  {
    path: '/kc',
    name: 'kc',
    meta: { title: '库存中心' },
    component: () => import('@/views/KcView')
  },
  {
    path: '/jzd',
    name: 'jzd',
    meta: { title: '结算单中心' },
    component: () => import('@/views/JzdView')
  },
  {
    path: '/cgd',
    name: 'cgd',
    meta: { title: '采购单中心' },
    component: () => import('@/views/CgdView')
  },
  {
    path: '/qrd',
    name: 'qrd',
    meta: { title: '确认申请单' },
    component: () => import('@/views/JctsqrView')
  },
  {
    path: '/gysgl',
    name: 'gysgl',
    meta: { title: '供应商管理' },
    component: () => import('@/views/GysglView')
  },
  {
    path: '/grej',
    name: 'grej',
    meta: { title: '供应商绑定' },
    component: () => import('@/views/GysRejView')
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录' },
    component: () => import('@/views/LoginView')
  },
  {
    path: '/examine',
    name: 'examine',
    meta: { title: '审核' },
    component: () => import('@/views/ExamineView')
  },
  {
    path: '/fmqy',
    name: 'fmqy',
    meta: { title: '采购单配送' },
    component: () => import('@/views/FmqyView')
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/index'
  }
]

const router = createRouter({
  base: 'jwspdwx',
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  // 动态标题
  const title = (to.meta.title ? to.meta.title : '')
  document.title = title || document.title
  next()
})

export default router
